export default __webpack_public_path__ + "static/media/bitcoinIcon.ece274f8.svg";